import React from 'react';
import { AlertTriangle, Video, Camera, Radio } from 'lucide-react';

const MediaConsentField = ({
    formData,
    setFormData,
    disabled = false
}) => {
    return (
        <div className="border-t border-white/10 pt-6 mt-6">
            <div className="flex items-center gap-2 mb-4">
                <Video className="w-5 h-5 text-primary" />
                <h3 className="font-heading font-bold text-sm uppercase">Media & Broadcasting Consent</h3>
                <span className="text-xs text-red-400 ml-2">(Required)</span>
            </div>

            <div className="space-y-4">
                {/* Disclaimer Box */}
                <div className="p-4 bg-[#0a1628] border border-yellow-500/30 rounded">
                    <div className="flex items-start gap-3">
                        <AlertTriangle className="w-5 h-5 text-yellow-400 flex-shrink-0 mt-0.5" />
                        <div className="space-y-3">
                            <p className="text-sm font-semibold text-yellow-400">
                                Important Notice - Media Coverage & Broadcasting
                            </p>
                            <p className="text-sm text-muted-foreground">
                                By registering for this platform, you acknowledge and consent to the following:
                            </p>
                            <ul className="text-sm text-muted-foreground space-y-2 list-disc list-inside">
                                <li className="flex items-start gap-2">
                                    <Camera className="w-4 h-4 text-primary flex-shrink-0 mt-0.5" />
                                    <span>Photographs and videos of the athlete may be captured during events and competitions</span>
                                </li>
                                <li className="flex items-start gap-2">
                                    <Radio className="w-4 h-4 text-primary flex-shrink-0 mt-0.5" />
                                    <span>Events may be telecasted live or recorded for broadcast on television, streaming platforms, and social media</span>
                                </li>
                                <li className="flex items-start gap-2">
                                    <Video className="w-4 h-4 text-primary flex-shrink-0 mt-0.5" />
                                    <span>Media coverage including press, photographers, and videographers will be present at events</span>
                                </li>
                            </ul>
                            <p className="text-sm text-muted-foreground">
                                These images and recordings may be used for promotional purposes, event highlights, news coverage, 
                                social media content, and archival purposes by the event organizers and affiliated media partners.
                            </p>
                        </div>
                    </div>
                </div>

                {/* Media Consent Checkbox */}
                <div className="flex items-start gap-3 p-4 bg-red-500/10 border border-red-500/30">
                    <input
                        type="checkbox"
                        id="media_consent"
                        checked={formData.media_consent || false}
                        onChange={(e) => setFormData({ ...formData, media_consent: e.target.checked })}
                        className="mt-1 w-5 h-5 accent-primary cursor-pointer"
                        disabled={disabled}
                        data-testid="media-consent-checkbox"
                    />
                    <label htmlFor="media_consent" className="text-sm cursor-pointer">
                        <span className="font-semibold text-red-400">Media Consent Agreement: * </span>
                        I hereby give my consent for the use of photographs, videos, and other media featuring the athlete 
                        for broadcasting, promotional, and media coverage purposes. I understand that these materials may be 
                        used in television broadcasts, online streaming, social media, promotional materials, and press coverage. 
                        I agree to the terms outlined above and confirm that I have the authority to provide this consent.
                    </label>
                </div>
            </div>
        </div>
    );
};

export default MediaConsentField;
